import { render, staticRenderFns } from "./activeLoans.vue?vue&type=template&id=eb0d041c"
import script from "./activeLoans.vue?vue&type=script&lang=js"
export * from "./activeLoans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports